import { Component, OnInit } from '@angular/core';
import { ProfileService } from 'src/app/data/repository/profile-repository/profile.service';
import { DateHelper } from 'src/app/utils/date-helper';
import { ChartInputModel } from 'src/app/core/model/input/chart-input-model';
import { WaterLogService } from 'src/app/data/repository/plan-repository/water-log.service';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { WaterLogDataService } from 'src/app/data/repository/plan-repository/water-log-data.service';

@Component({
  selector: 'app-profile-water-chart',
  templateUrl: './profile-water-chart.component.html',
  styleUrls: ['./profile-water-chart.component.scss'],
})
export class ProfileWaterChartComponent implements OnInit {
  average = 0;
  startDate: Date;
  endDate: Date;
  page = 0;
  title: string;
  segment = 0;
  segmentTitle = 'روزانه';
  barChartInput: ChartInputModel;

  showLoading = false;

  constructor(
    private profileService: ProfileService,
    private dateHelper: DateHelper,
    private waterLogService: WaterLogService,
    private snackBarService: SnackBarService,
    private waterLogDataService: WaterLogDataService
  ) {
    this.prepare();
  }

  ngOnInit() {}

  nextDays() {
    this.page++;
    this.prepare();
  }

  previousDays() {
    this.page--;
    this.prepare();
  }

  back() {
    this.profileService.goBack();
  }

  prepare() {
    this.showLoading = true;
    const period = this.segment === 2 ? 120 : this.segment === 1 ? 28 : 4;
    this.startDate = new Date(
      new Date().setDate(new Date().getDate() + period * this.page)
    );
    this.endDate = new Date(
      new Date().setDate(
        new Date().getDate() + (period * this.page - period + 1)
      )
    );
    this.segmentTitle =
      this.segment === 2 ? 'ماهانه' : this.segment === 1 ? 'هفتگی' : 'روزانه';
    const startDateString =
      this.segment !== 2
        ? this.dateHelper.getYearAndMonthAndDayPersian(this.startDate)
        : this.dateHelper.getYearAndMonthPersian(this.startDate);
    const endDateString =
      this.segment !== 2
        ? this.dateHelper.getYearAndMonthAndDayPersian(this.endDate)
        : this.dateHelper.getYearAndMonthPersian(this.endDate);
    this.title = endDateString + ' - ' + startDateString;
    this.calculateWaterInputLabels();
  }

  calculateWaterInputLabels() {
    const labels = ['', '', '', ''];
    const period = this.segment === 2 ? 120 : this.segment === 1 ? 28 : 4;
    for (let i = 0; i < 4; i++) {
      const date = new Date(
        new Date().setDate(
          new Date().getDate() + (period * this.page - (i * period) / 4)
        )
      );
      if (this.segment === 0 && this.dateHelper.isSameDay(date, new Date())) {
        labels[i] = 'امروز';
      } else if (
        this.segment === 0 &&
        this.dateHelper.isSameDay(
          date,
          new Date(new Date().setDate(new Date().getDate() - 1))
        )
      ) {
        labels[i] = 'دیروز';
      } else if (this.segment === 2) {
        labels[i] = this.dateHelper.getPersianMonthName(date);
      } else {
        labels[i] = this.dateHelper.getMonthAndDayPersian(date);
      }
    }
    const data = [0, 0, 0, 0];
    this.barChartInput = new ChartInputModel(labels, data);
    this.prepareWaterInputAmounts(labels);
  }

  async prepareWaterInputAmounts(labels: string[]) {
    let startDate = new Date(this.startDate);
    startDate = new Date(startDate.setDate(startDate.getDate() + 1));
    startDate = new Date(startDate.setHours(0, 0, 0, 0));
    let endDate = new Date(this.endDate);
    endDate = new Date(endDate.setHours(0, 0, 0, 0));
    const period = this.segment === 2 ? 120 : this.segment === 1 ? 28 : 4;
    this.average = 0;

    const waterlogApiResponse = await this.waterLogService.getWater();
    if (waterlogApiResponse.isSuccess()) {
      const wls = await this.waterLogDataService.getCustomWaterLogs(
        startDate.getTime(),
        endDate.getTime()
      );
      const amounts = [0, 0, 0, 0];
      const counters = [0, 0, 0, 0];
      const data = [0, 0, 0, 0];
      wls.waterlogs.forEach((waterlog) => {
        const diffDays = Math.floor(
          (startDate.getTime() - waterlog.date) / (24 * 60 * 60 * 1000)
        );
        const index = Math.floor(diffDays / (period / 4));
        amounts[index] += waterlog.amount;
        counters[index]++;
        this.average += waterlog.amount;
      });
      for (let i = 0; i < 4; i++) {
        data[i] = counters[i] !== 0 ? Math.ceil(amounts[i] / counters[i]) : 0;
      }
      this.average =
        wls.waterlogs.length !== 0
          ? Math.ceil(this.average / wls.waterlogs.length)
          : 0;
      this.barChartInput = new ChartInputModel(labels, data);
      this.showLoading = false;
    } else {
      this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      this.showLoading = false;
    }
  }

  segmentSelected(segment: number) {
    if (this.segment !== segment) {
      this.page = 0;
      this.segment = segment;
      this.prepare();
      document.getElementById('segment0').style.color = '#000000';
      document.getElementById('segment1').style.color = '#000000';
      document.getElementById('segment2').style.color = '#000000';
      document.getElementById('selected-segment').style.right =
        this.segment === 2
          ? 'calc( 66% - 2px )'
          : this.segment === 1
          ? 'calc( 34% - 2px )'
          : '2px';
      setTimeout(() => {
        document.getElementById('segment' + segment).style.color = '#0073ff';
      }, 100);
    }
  }
}
